import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor() {
    this.initHeader();
  }

  baseUrl = environment.baseUrl;
  headers: any;

  initHeader() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }
}
